import React from 'react';

interface PasswordIconProps {
  className?: string;
}

const PasswordIcon: React.FC<PasswordIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 7V5a4 4 0 018 0v2" stroke="currentColor" strokeWidth="1" fill="none"/>
    <rect x="2" y="7" width="12" height="7" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
    <circle cx="8" cy="10" r="1" fill="currentColor"/>
  </svg>
);

export default PasswordIcon;